import React, { useCallback } from 'react';
import { Handle, Position } from 'reactflow';
import { 
  Box,
  TextField,
  Typography
} from '@mui/material';

export const PremiumNode = ({ data, selected, id }) => {
  const handleChange = useCallback((event) => {
    event.stopPropagation();
    const value = parseInt(event.target.value) || 0;
    data.onChange?.(value);
  }, [data]);

  return (
    <div className="react-flow__node-default" style={{ minWidth: 250 }}>
      <Handle
        type="target"
        position={Position.Left}
        style={{ 
          left: 0,
          top: 24,
          transform: 'translateY(-50%)'
        }}
      />
      
      <div className="condition-label">
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          width: '100%'
        }}>
          <Typography variant="body2">Premium</Typography>
          <Typography variant="body2" color="white" className="premium-value" sx={{ padding: '0 6px', borderRadius: 1 }}>
            {data.value || 0}
          </Typography>
        </Box>
      </div>

      <Box sx={{ 
        padding: 2, 
        paddingTop: 0,
        display: 'flex',
        flexDirection: 'column',
        gap: 1
      }}>
        <TextField
          type="number"
          value={data.value || 0}
          onChange={handleChange}
          placeholder="Enter price"
          size="small"
          className="nodrag"
          onMouseDown={e => e.stopPropagation()}
          inputProps={{
            min: 0,
            step: 1
          }}
        />
      </Box>

      <Handle
        type="source"
        position={Position.Right}
        id="true"
        style={{
          right: 0,
          top: 24,
          transform: 'translateY(-50%)'
        }}
      />
    </div>
  );
};
